import { createContext, useContext, useEffect, useState } from "react";

export type ExperienceType = "delivery" | "restaurant" | null;

type Ctx = {
  experience: ExperienceType;
  setExperience: (v: ExperienceType) => void;
};

const ExperienceContext = createContext<Ctx>({
  experience: null,
  setExperience: () => {},
});

export const ExperienceProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [experience, setExperienceState] = useState<ExperienceType>(null);

  useEffect(() => {
    const saved =
      (localStorage.getItem("experience") as ExperienceType) || null;
    if (saved) setExperienceState(saved);
  }, []);

  const setExperience = (v: ExperienceType) => {
    setExperienceState(v);
    if (v) localStorage.setItem("experience", v);
    else localStorage.removeItem("experience");
  };

  return (
    <ExperienceContext.Provider value={{ experience, setExperience }}>
      {children}
    </ExperienceContext.Provider>
  );
};

export const useExperience = () => useContext(ExperienceContext);
